import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResult, IUserDto, IUsersQueryParams } from 'gen/ApiClient';

export const UsersQueryContext = React.createContext<IQueryContext<IQueryResult<IUserDto>, IUsersQueryParams>>(undefined as any);
